import { forwardRef } from "react";
import { Link } from "react-router-dom";

/**
 * SaaS premium button. Variants tuned to the gold/dark cinematic palette.
 * Can render as <Link to={to}> when `to` is passed.
 */
const base =
  "inline-flex items-center justify-center gap-2 font-semibold tracking-tight " +
  "rounded-md transition-all duration-200 disabled:opacity-50 disabled:cursor-not-allowed " +
  "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-gold/70 focus-visible:ring-offset-2 focus-visible:ring-offset-bg";

const variants = {
  primary:
    "bg-gold text-black hover:bg-gold-hover hover:shadow-[0_8px_32px_-8px_rgba(245,166,35,0.6)] active:translate-y-[1px]",
  outline:
    "bg-transparent text-white border border-white/15 hover:bg-white/5 hover:border-white/30",
  ghost:
    "bg-transparent text-white/80 hover:text-white hover:bg-white/5",
  dark:
    "bg-white text-black hover:bg-white/90",
  danger:
    "bg-err/15 text-err border border-err/40 hover:bg-err/25",
};

const sizes = {
  sm: "h-9 px-4 text-sm",
  md: "h-11 px-6 text-sm",
  lg: "h-14 px-8 text-base",
};

const SButton = forwardRef(function SButton(
  { variant = "primary", size = "md", to, href, icon: Icon, iconRight: IconR, className = "", children, ...rest },
  ref
) {
  const cls = `${base} ${variants[variant] || variants.primary} ${sizes[size] || sizes.md} ${className}`;
  const body = (
    <>
      {Icon ? <Icon className="w-4 h-4" /> : null}
      <span>{children}</span>
      {IconR ? <IconR className="w-4 h-4" /> : null}
    </>
  );
  if (to)   return <Link ref={ref} to={to}   className={cls} {...rest}>{body}</Link>;
  if (href) return <a    ref={ref} href={href} className={cls} {...rest}>{body}</a>;
  return <button ref={ref} className={cls} {...rest}>{body}</button>;
});

export default SButton;
